import { PropsWithChildren } from 'react'

export function InvalidMessage(props: PropsWithChildren<{}>) {
  return <span className="mt-2 text-red-400 text-sm">{props.children}</span>
}
